import AuthService from '../services/auth.service';

const user = JSON.parse(localStorage.getItem('user'));
const token = localStorage.getItem('token');
const initialState = user
    ? { status: { loggedIn: true }, user, token }
    : { status: { loggedIn: false }, user: null, token: null };

export const auth = {
    namespaced: true,
    state: initialState,
    actions: {
        login() {
            AuthService.login();
        },
        logout({ commit }) {
            commit('logout');
            AuthService.logout();
        },
    },
    mutations: {
        loginSuccess(state, user, token, idToken) {
            state.status.loggedIn = true;
            state.user = user;
            state.token = token;
            state.idToken = idToken;
        },
        setClientId(state, value) {
            state.user.clientId = value;
        },
        loginFailure(state) {
            state.status.loggedIn = false;
            state.user = null;
            state.token = null;
            state.idToken = null;
        },
        logout(state) {
            state.status.loggedIn = false;
            state.user = null;
            state.token = null;
            state.idToken = null;
        }
    }
};
